export const AdminResourceHintsAuditController = {
    index(): void {},
};
